module.exports = __webpack_public_path__ + "static/media/cover.d3aac75e.svg";